import type { ShippingAddress } from '../../../modules/api';

export interface AddressLinesProps {
  address: ShippingAddress;
}

/**
 * The address text block (name / lines / city-state-zip / phone). Colour is
 * inherited from the parent via `currentColor` + opacity, so the same markup
 * reads on the dark Delivery page (white text, AddressBlock) and inside the
 * light address picker (dark text, SelectableAddressRow).
 */
export function AddressLines({ address }: AddressLinesProps) {
  return (
    <div className="min-w-0 text-[14px] leading-[20px]">
      <div className="font-semibold">{address.name}</div>
      <div style={{ opacity: 0.7 }}>
        {address.firstLine}
        {address.secondLine ? `, ${address.secondLine}` : ''}
      </div>
      <div style={{ opacity: 0.7 }}>
        {[address.city, address.state, address.zipcode].filter(Boolean).join(', ')}
        {address.country ? ` · ${address.country}` : ''}
      </div>
      {address.phoneNumber && (
        <div className="mt-1" style={{ opacity: 0.55 }}>
          {address.phoneNumber}
        </div>
      )}
    </div>
  );
}
